import { render, staticRenderFns } from "./PokedexCard.vue?vue&type=template&id=d88d27f0&scoped=true"
import script from "./PokedexCard.vue?vue&type=script&lang=js"
export * from "./PokedexCard.vue?vue&type=script&lang=js"
import style0 from "./PokedexCard.vue?vue&type=style&index=0&id=d88d27f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88d27f0",
  null
  
)

export default component.exports